import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import moment from "moment";
import { CategoryChartData } from "@/models/category-chart-data";
import { InvoiceListEntry } from "@/models/invoice-list-entry";

@Module({ name: "AnalyticsStore", namespaced: true })
class AnalyticsStore extends VuexModule {
  private dateRange: { [key: string]: string } = {
    startDate: moment()
      .subtract(1, "weeks")
      .format()
      .toString()
      .substring(0, 10),
    endDate: moment()
      .format()
      .toString()
      .substring(0, 10)
  };
  private selectedSite = "";
  private recogByHeaderFieldData: CategoryChartData[] = [];
  private recogBySupplierData: CategoryChartData[] = [];
  private searchButtonClicked = 0;
  private selectedInvoice: null | InvoiceListEntry = null;
  private selectedInvoicePdfLocation = "";

  @Mutation
  private setDateRange(dateRange: { [key: string]: string }) {
    this.dateRange = dateRange;
  }

  @Mutation
  private setRecogByHeaderFieldData(data: CategoryChartData[]) {
    this.recogByHeaderFieldData = data;
  }

  @Mutation
  private setRecogBySupplierData(data: CategoryChartData[]) {
    this.recogBySupplierData = data;
  }

  @Mutation
  private setSearchButtonClicked() {
    this.searchButtonClicked += 1;
  }

  @Mutation
  private setSelectedSite(site: string) {
    this.selectedSite = site;
  }

  @Mutation
  private setSelectedInvoice(invoice: InvoiceListEntry | null) {
    this.selectedInvoice = invoice;
    if (invoice === null) {
      this.selectedInvoicePdfLocation = "";
    }
  }

  @Mutation
  private setSelectedInvoicePdfLocation(location: Uint8Array | string) {
    if (typeof location !== "string") {
      // convert ArrayBuffer to Blob
      const bytes = new Uint8Array(location);
      const blob = new Blob([bytes], { type: "application/pdf" });
      // create data URL from Blob
      this.selectedInvoicePdfLocation = window.URL.createObjectURL(blob);
    } else {
      this.selectedInvoicePdfLocation = location;
    }
  }

  @Action({ rawError: true })
  public updateDateRange(dateRange: { [key: string]: string }) {
    this.context.commit("setDateRange", dateRange);
  }

  @Action({ rawError: true })
  public updateRecogByHeaderFieldData(data: CategoryChartData[]) {
    this.context.commit("setRecogByHeaderFieldData", data);
  }

  @Action({ rawError: true })
  public updateRecogBySupplierData(data: CategoryChartData[]) {
    this.context.commit("setRecogBySupplierData", data);
  }

  @Action({ rawError: true })
  public clickAnalyticsSearchButton() {
    this.context.commit("setSearchButtonClicked");
  }

  @Action({ rawError: true })
  public updateSelectedSite(site: string) {
    this.context.commit("setSelectedSite", site);
  }

  @Action({ rawError: true })
  public updateSelectedInvoice(invoice: InvoiceListEntry | null) {
    this.context.commit("setSelectedInvoice", invoice);
  }

  @Action({ rawError: true })
  public updateSelectedInvoicePdfLocation(location: ArrayBuffer | string) {
    this.context.commit("setSelectedInvoicePdfLocation", location);
  }

  public get getDateRange(): { [key: string]: string } {
    return this.dateRange;
  }

  public get getRecogByHeaderFieldData(): CategoryChartData[] {
    return this.recogByHeaderFieldData;
  }

  public get getRecogBySupplierData(): CategoryChartData[] {
    return this.recogBySupplierData;
  }

  public get getSearchButtonClicked(): number {
    return this.searchButtonClicked;
  }

  public get getSelectedSite(): string {
    return this.selectedSite;
  }

  public get getSelectedInvoice(): null | InvoiceListEntry {
    return this.selectedInvoice;
  }

  public get getSelectedInvoicePdfLocation(): string {
    return this.selectedInvoicePdfLocation;
  }
}

export default AnalyticsStore;
